<template>
  <div
    placement="bottom-start"
    trigger="click"
    :class="[
      'el-color-picker',
      colorDisabled ? 'is-disabled' : '',
      colorSize ? `el-color-picker--${colorSize}` : ''
    ]"
    v-click-outside="hide"
  >
    <div
      slot="reference"
      class="el-color-picker__trigger"
      @mousedown.prevent
      @click="handleTrigger"
    >
      <slot></slot>
    </div>
    <div slot="dropdown">
      <picker-dropdown
        ref="dropdown"
        :class="['el-color-picker__panel', popperClass || '']"
        v-model="showPicker"
        @pick="confirmValue"
        @clear="clearValue"
        :showClear="showClear"
        :color="color"
        :show-alpha="showAlpha"
        :predefine="predefine"
      >
      </picker-dropdown>
    </div>
  </div>
</template>

<script>
import vClickOutside from "v-click-outside";
import Color from "./color";
import PickerDropdown from "./components/picker-dropdown.vue";
import Emitter from "./emitter";

export default {
  directives: {
    clickOutside: vClickOutside.directive
  },
  mixins: [Emitter],

  props: {
    value: String,
    showAlpha: Boolean,
    colorFormat: String,
    disabled: Boolean,
    size: String,
    popperClass: String,
    predefine: Array,
    showClear: {
      default: true,
      type: Boolean
    }
  },

  inject: {
    elForm: {
      default: ""
    },
    elFormItem: {
      default: ""
    }
  },

  computed: {
    displayedColor() {
      if (!this.value && !this.showPanelColor) {
        return "transparent";
      }

      return this.displayedRgb(this.color, this.showAlpha);
    },

    _elFormItemSize() {
      return (this.elFormItem || {}).elFormItemSize;
    },

    colorSize() {
      return this.size || this._elFormItemSize || (this.$ELEMENT || {}).size;
    },

    colorDisabled() {
      return this.disabled || (this.elForm || {}).disabled;
    }
  },

  watch: {
    value(val) {
      if (!val) {
        this.showPanelColor = false;
      } else if (val && val !== this.color.value) {
        this.color.fromString(val);
      }
    },
    color: {
      deep: true,
      handler() {
        this.showPanelColor = true;
      }
    },
    displayedColor(val) {
      if (!this.showPicker) return;
      const currentValueColor = new Color({
        enableAlpha: this.showAlpha,
        format: this.colorFormat
      });
      currentValueColor.fromString(this.value);

      const currentValueColorRgb = this.displayedRgb(
        currentValueColor,
        this.showAlpha
      );
      if (val !== currentValueColorRgb) {
        this.$emit("active-change", val);
      }
    }
  },

  methods: {
    handleTrigger() {
      if (this.colorDisabled) return;
      this.showPicker = !this.showPicker;
    },
    confirmValue() {
      const value = this.color.value;
      this.$emit("input", value);
      this.$emit("change", value);
      this.dispatch("ElFormItem", "el.form.change", value);
      this.showPicker = false;
    },
    clearValue() {
      this.$emit("reset");
      // this.$emit("input", null);
      // this.$emit("change", null);
      // if (this.value !== null) {
      //   this.dispatch("ElFormItem", "el.form.change", null);
      // }
      // this.showPanelColor = false;
      // this.showPicker = false;
      // this.resetColor();
    },
    hide() {
      this.showPicker = false;
      this.resetColor();
    },
    resetColor() {
      this.$nextTick(() => {
        if (this.value) {
          this.color.fromString(this.value);
        } else {
          this.showPanelColor = false;
        }
      });
    },
    displayedRgb(color, showAlpha) {
      if (!(color instanceof Color)) {
        throw Error("color should be instance of Color Class");
      }

      const { r, g, b } = color.toRgb();
      return showAlpha
        ? `rgba(${r}, ${g}, ${b}, ${color.get("alpha") / 100})`
        : `rgb(${r}, ${g}, ${b})`;
    }
  },

  mounted() {
    const value = this.value;
    if (value) {
      this.color.fromString(value);
    }
    this.popperElm = this.$refs.dropdown.$el;
  },

  data() {
    const color = new Color({
      enableAlpha: this.showAlpha,
      format: this.colorFormat
    });

    return {
      color,
      showPicker: false,
      showPanelColor: false
    };
  },

  components: {
    PickerDropdown
  }
};
</script>

<style>
.el-color-predefine {
  display: flex;
  font-size: 12px;
  margin-top: 8px;
  width: 280px;
}

.el-color-predefine__colors {
  display: flex;
  flex: 1;
  flex-wrap: wrap;
}

.el-color-predefine__color-selector {
  margin: 0 0 8px 8px;
  width: 20px;
  height: 20px;
  border-radius: 4px;
  cursor: pointer;
}

.el-color-predefine__color-selector:nth-child(10n + 1) {
  margin-left: 0;
}

.el-color-predefine__color-selector.selected {
  box-shadow: 0 0 3px 2px #409eff;
}

.el-color-predefine__color-selector > div {
  display: flex;
  height: 100%;
  border-radius: 3px;
}

.el-color-hue-slider {
  position: relative;
  box-sizing: border-box;
  width: 280px;
  height: 12px;
  background-color: red;
  padding: 0 2px;
}

.el-color-hue-slider__bar {
  position: relative;
  background: linear-gradient(
    to right,
    red 0,
    #ff0 17%,
    #0f0 33%,
    #0ff 50%,
    #00f 67%,
    #f0f 83%,
    red 100%
  );
  height: 100%;
}
.el-color-hue-slider__thumb {
  position: absolute;
  cursor: pointer;
  box-sizing: border-box;
  left: 0;
  top: 0;
  width: 4px;
  height: 100%;
  border-radius: 1px;
  background: #fff;
  border: 1px solid #f0f0f0;
  box-shadow: 0 0 2px rgba(0, 0, 0, 0.6);
  z-index: 1;
}
.el-color-hue-slider.is-vertical {
  width: 12px;
  height: 180px;
  padding: 2px 0;
}
.el-color-hue-slider.is-vertical .el-color-hue-slider__bar {
  background: linear-gradient(
    to bottom,
    red 0,
    #ff0 17%,
    #0f0 33%,
    #0ff 50%,
    #00f 67%,
    #f0f 83%,
    red 100%
  );
}
.el-color-hue-slider.is-vertical .el-color-hue-slider__thumb {
  left: 0;
  top: 0;
  width: 100%;
  height: 4px;
}
.el-color-svpanel {
  position: relative;
  width: 280px;
  height: 180px;
}
.el-color-svpanel__black,
.el-color-svpanel__white {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}
.el-color-svpanel__white {
  background: linear-gradient(to right, #fff, rgba(255, 255, 255, 0));
}
.el-color-svpanel__black {
  background: linear-gradient(to top, #000, rgba(0, 0, 0, 0));
}
.el-color-svpanel__cursor {
  position: absolute;
}
.el-color-svpanel__cursor > div {
  cursor: head;
  width: 4px;
  height: 4px;
  box-shadow: 0 0 0 1.5px #fff, inset 0 0 1px 1px rgba(0, 0, 0, 0.3),
    0 0 1px 2px rgba(0, 0, 0, 0.4);
  border-radius: 50%;
  transform: translate(-2px, -2px);
}
.el-color-alpha-slider {
  position: relative;
  box-sizing: border-box;
  width: 280px;
  height: 12px;
  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMCAIAAADZF8uwAAAAGUlEQVQYV2M4gwH+YwCGIasIUwhT25BVBADtzYNYrHvv4gAAAABJRU5ErkJggg==);
}
.el-color-alpha-slider__bar {
  position: relative;
  background: linear-gradient(to right, rgba(255, 255, 255, 0) 0, #fff 100%);
  height: 100%;
}
.el-color-alpha-slider__thumb {
  position: absolute;
  cursor: pointer;
  box-sizing: border-box;
  left: 0;
  top: 0;
  width: 4px;
  height: 100%;
  border-radius: 1px;
  background: #fff;
  border: 1px solid #f0f0f0;
  box-shadow: 0 0 2px rgba(0, 0, 0, 0.6);
  z-index: 1;
}
.el-color-alpha-slider.is-vertical {
  width: 20px;
  height: 180px;
}
.el-color-alpha-slider.is-vertical .el-color-alpha-slider__bar {
  background: linear-gradient(to bottom, rgba(255, 255, 255, 0) 0, #fff 100%);
}
.el-color-alpha-slider.is-vertical .el-color-alpha-slider__thumb {
  left: 0;
  top: 0;
  width: 100%;
  height: 4px;
}
.el-color-dropdown {
  width: 300px;
}
.el-color-dropdown__main-wrapper {
  margin-bottom: 6px;
}
.el-color-dropdown__main-wrapper::after {
  content: "";
  display: table;
  clear: both;
}
.el-color-dropdown__btns {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 6px;
  text-align: right;
}
.el-color-dropdown__value {
  float: left;
  line-height: 26px;
  font-size: 12px;
  color: #000;
  width: 160px;
}
.el-color-dropdown__btn {
  border: 1px solid #dcdcdc;
  color: #333;
  line-height: 24px;
  border-radius: 2px;
  padding: 0 10px;
  cursor: pointer;
  background-color: transparent;
  outline: 0;
  font-size: 12px;
}
.el-color-dropdown__btn[disabled] {
  color: #ccc;
  cursor: not-allowed;
}
.el-color-dropdown__btn:hover {
  color: #409eff;
  border-color: #409eff;
}
.el-color-dropdown__link-btn {
  cursor: pointer;
  color: #409eff;
  text-decoration: none;
  font-size: 12px;
}
.el-color-dropdown__link-btn:hover {
  color: tint(#409eff, 20%);
}
.el-color-picker {
  display: inline-block;
  position: relative;
  line-height: normal;
  /*height: 40px;*/
}
.el-color-picker.is-disabled .el-color-picker__trigger {
  cursor: not-allowed;
}
.el-color-picker__trigger {
  /*display: inline-block;*/
  position: relative;
  cursor: pointer;
}
.el-color-picker__panel {
  position: absolute;
  z-index: 9999 !important;
  padding: 6px;
  box-sizing: content-box;
  background-color: #fff;
  border: 1px solid #ebeef5;
  border-radius: 4px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}
</style>
